import {
    FETCH_ASSETSECURITY_BEGIN,
    FETCH_ASSETSECURITY_SUCCESS,
    FETCH_ASSETSECURITY_FAILURE,
    FETCH_ASSETINVESTMENT_BEGIN,
    FETCH_ASSETINVESTMENT_SUCCESS,
    FETCH_ASSETINVESTMENT_FAILURE,
    FETCH_ASSETCLASS_BEGIN,
    FETCH_ASSETCLASS_SUCCESS,
    FETCH_ASSETCLASS_FAILURE,

    FETCH_FUNDSTATUS_BEGIN,
    FETCH_FUNDSTATUS_SUCCESS,
    FETCH_FUNDSTATUS_FAILURE,

    FETCH_PRIMARYANALYST_BEGIN,
    FETCH_PRIMARYANALYST_SUCCESS,
    FETCH_PRIMARYANALYST_FAILURE,

    FETCH_SECONDARYANALYST_BEGIN,
    FETCH_SECONDARYANALYST_SUCCESS,
    FETCH_SECONDARYANALYST_FAILURE,

    FETCH_STRATEGY_BEGIN,
    FETCH_STRATEGY_SUCCESS,
    FETCH_STRATEGY_FAILURE,

    FETCH_SUBSTRATEGY_BEGIN,
    FETCH_SUBSTRATEGY_SUCCESS,
    FETCH_SUBSTRATEGY_FAILURE,

    FETCH_REGION_BEGIN,
    FETCH_REGION_SUCCESS,
    FETCH_REGION_FAILURE,

    FETCH_SUBREGION_BEGIN,
    FETCH_SUBREGION_SUCCESS,
    FETCH_SUBREGION_FAILURE,

    FETCH_SECTOR_BEGIN,
    FETCH_SECTOR_SUCCESS,
    FETCH_SECTOR_FAILURE,

    FETCH_SUBSECTOR_BEGIN,
    FETCH_SUBSECTOR_SUCCESS,
    FETCH_SUBSECTOR_FAILURE,

    FETCH_ASSETAUMDETAILS_BEGIN,
    FETCH_ASSETAUMDETAILS_SUCCESS,
    FETCH_ASSETAUMDETAILS_FAILURE,

    FETCH_ASSETRETURNS_BEGIN,
    FETCH_ASSETRETURNS_SUCCESS,
    FETCH_ASSETRETURNS_FAILURE,

    FETCH_ASSETSHARECLASSTERMS_BEGIN,
    FETCH_ASSETSHARECLASSTERMS_SUCCESS,
    FETCH_ASSETSHARECLASSTERMS_FAILURE,

    FETCH_ASSETPRIVATEEXPOSURE_BEGIN,
    FETCH_ASSETPRIVATEEXPOSURE_SUCCESS,
    FETCH_ASSETPRIVATEEXPOSURE_FAILURE
} from '../constants/assetdetails';

const initialState={
   assetSecurityType:[],
   assetInvestStatus:[],
   assetClass:[],
   fundStatus:[],
   primaryAnalyst:[],
   secondaryAnalyst:[],
   strategy:[],
   substrategy:[],
   region:[],
   subregion:[],
   sector:[],
    subsector: [],
    assetAUM: [],
    assetReturns: [],
    assetShareClassTerms:[],
    assetPrivateExposureSummary:[],
    isLoading:false,
    error:"",
    assetReturnsLoad:false
}

// Asset Details Get SecurityType...
export const getAssetDetailsReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETSECURITY_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETSECURITY_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            assetSecurityType:payload.securityType         
        };
    case FETCH_ASSETSECURITY_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}
//Get Investment Status...
export const getAssetInvestReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETINVESTMENT_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETINVESTMENT_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            assetInvestStatus:payload.Investmentstatus         
        };
    case FETCH_ASSETINVESTMENT_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}
// Get Asset Class...
export const getAssetClassReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETCLASS_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETCLASS_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            assetClass:payload.assetClass         
        };
    case FETCH_ASSETCLASS_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

// Fund Status 
export const getFundStatusReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_FUNDSTATUS_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_FUNDSTATUS_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            fundStatus:payload.fundStatus         
        };
    case FETCH_FUNDSTATUS_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}


// primaryAnalyst 
export const getPrimaryAnalystReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_PRIMARYANALYST_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_PRIMARYANALYST_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            primaryAnalyst:payload.primaryAnalyst         
        };
    case FETCH_PRIMARYANALYST_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}


// secondaryAnalyst 
export const getSecondaryAnalystReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_SECONDARYANALYST_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_SECONDARYANALYST_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            secondaryAnalyst:payload.secondaryAnalyst         
        };
    case FETCH_SECONDARYANALYST_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}


// Strategy
export const getStrategyReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_STRATEGY_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_STRATEGY_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            strategy:payload.strategy         
        };
    case FETCH_STRATEGY_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}


// SubStrategy
export const getSubStrategyReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_SUBSTRATEGY_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_SUBSTRATEGY_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            subStrategy:payload.subStrategy         
        };
    case FETCH_SUBSTRATEGY_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

// Region
export const getRegionReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_REGION_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_REGION_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            region:payload.region         
        };
    case FETCH_REGION_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

// sub Region
export const getSubRegionReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_SUBREGION_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_SUBREGION_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            subregion:payload.subregion         
        };
    case FETCH_SUBREGION_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

//  sector
export const getSectorReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_SECTOR_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_SECTOR_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            sector:payload.sector         
        };
    case FETCH_SECTOR_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

// sub sector
export const getSubSectorReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_SUBSECTOR_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_SUBSECTOR_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            subsector:payload.subsector         
        };
    case FETCH_SUBSECTOR_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

//Asset AUM

export const getAssetAUMWidgetReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETAUMDETAILS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETAUMDETAILS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                assetAUM: payload.assetAUM
            };
        case FETCH_ASSETAUMDETAILS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Asset Returns

export const getAssetReturnsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETRETURNS_BEGIN: {
            return {
                ...initialState,
                assetReturnsLoad: true,
                error: null,
                assetReturns:[]
            };
        }
        case FETCH_ASSETRETURNS_SUCCESS:
            return {
                ...initialState,
                assetReturnsLoad: false,
                assetReturns: payload.assetReturns
            };
        case FETCH_ASSETRETURNS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                assetReturnsLoad: false,
                assetReturns:[]
            };
        default:
            return state;
    }
}

//Asset ShareClassTerms

export const getAssetShareclassTermsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSHARECLASSTERMS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSHARECLASSTERMS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                assetShareClassTerms: payload.assetShareClassTerms
            };
        case FETCH_ASSETSHARECLASSTERMS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Asset ShareClassTerms

export const getAssetPrivateExposureSummaryReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETPRIVATEEXPOSURE_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETPRIVATEEXPOSURE_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                assetPrivateExposureSummary: payload.assetPrivateExposureSummary
            };
        case FETCH_ASSETPRIVATEEXPOSURE_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}